import { type TSubscriptionProblemPayload } from '@app/react/components/SubscriptionUpgradePrompt/SubscriptionUpgradePrompt.types';

import { extractProblemJson } from './extractProblemJson.function';

const _isRecord = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
};

/**
 * Extracts a subscription problem payload from a 402 error response.
 * Returns null if the error is not a 402 or does not contain a valid subscription problem.
 */
export const extractSubscriptionProblem = (error: unknown): TSubscriptionProblemPayload | null => {
  if (!_isRecord(error)) return null;

  const status = (error as { status?: unknown }).status;
  if (status !== 402) return null;

  const problem = extractProblemJson(error.payload)?.record;
  if (!problem) return null;

  // Validate that this is a subscription problem by checking for required fields
  if (
    typeof problem.restriction !== 'string' ||
    !Array.isArray(problem.required_tiers) ||
    !_isRecord(problem.allowed_range) ||
    !_isRecord(problem.subscription_access)
  ) {
    return null;
  }

  // Type-cast to the expected payload shape after validation
  return problem as TSubscriptionProblemPayload;
};
